/**
 * Conflict resolution context – when server has a newer update than the client's pending change,
 * surface for tournament admin to choose: use server version or overwrite with local version.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const ConflictContext = createContext();

export function useConflict() {
  return useContext(ConflictContext);
}

export function ConflictProvider({ children }) {
  const [conflicts, setConflicts] = useState([]);

  const addConflict = useCallback((payload) => {
    setConflicts((prev) => [...prev, { id: 'c_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9), ...payload }]);
  }, []);

  const resolveConflict = useCallback((id, action) => {
    setConflicts((prev) => prev.filter((c) => c.id !== id));
    return action;
  }, []);

  const value = { conflicts, addConflict, resolveConflict };

  return (
    <ConflictContext.Provider value={value}>
      {children}
    </ConflictContext.Provider>
  );
}
